import { render, staticRenderFns } from "./cd-chat-log.vue?vue&type=template&id=ff717c20"
import script from "./cd-chat-log.vue?vue&type=script&lang=js"
export * from "./cd-chat-log.vue?vue&type=script&lang=js"
import style0 from "./cd-chat-log.vue?vue&type=style&index=0&id=ff717c20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports